export const DATING             = 111
export const ADULT_DATING       = 9
export const CASUAL_DATING      = 10
export const MATCHMAKING_DATING = 11
export const ALL_SUB            = [ADULT_DATING, CASUAL_DATING, MATCHMAKING_DATING]